import React from 'react'

import { Box, Icon, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface CollapsableCardHeaderProps extends React.PropsWithChildren {
  title: string
  description?: string
  tag?: string
  disabled?: boolean
  showDescription?: boolean
  infoTooltipLabel?: string
}

export const CollapsableCardHeader = ({
  title,
  description,
  tag,
  disabled,
  children,
  showDescription,
  infoTooltipLabel,
}: CollapsableCardHeaderProps) => {
  const [openTooltip, toggleTooltip] = useToggle(false)

  const showTextDescription = description && showDescription

  const gap = showTextDescription ? 's8' : 's0'
  const textColor = disabled ? 'grey600' : 'grey1000'

  const showTooltip = showTextDescription && infoTooltipLabel

  return (
    <Box textAlign="left" gap={gap}>
      <Box
        flexDirection="row"
        justifyContent="spaceBetween"
        gap="s16"
        paddingX="s8"
        alignItems="center"
      >
        <Box style={{ maxWidth: '90%' }} flexDirection="row" alignItems="center" gap="s8">
          <Text.Normal weight="medium" lineClamp={3} color={textColor}>
            {title}
          </Text.Normal>
          <Box minWidth="fit-content">{tag && <Tag type="brandLight">{tag}</Tag>}</Box>
        </Box>
        {children}
      </Box>
      <Box flexDirection="row" alignItems="center" paddingX="s8">
        {showTextDescription && (
          <Text.Normal color={textColor} size="200" lineClamp={3}>
            {description}
          </Text.Normal>
        )}
        {showTooltip && (
          <Tooltip.Alt
            attachment="bottom left"
            open={openTooltip}
            toggle={toggleTooltip}
            label={infoTooltipLabel}
          >
            <Icon.Medium icon="info-circle-line" color="grey800" />
          </Tooltip.Alt>
        )}
      </Box>
    </Box>
  )
}
